module.exports = __webpack_public_path__ + "img/logocompleta.a5c4077e.png";